import { render } from "./SystemAdmin7.vue?vue&type=template&id=4ad9dda0"
import script from "./SystemAdmin7.vue?vue&type=script&lang=js"
export * from "./SystemAdmin7.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__